<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-40" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="20">
            <h6><a @click="goToMainPage" class="mr-5"><a-icon type="arrow-left" /></a>IC Design Booking System</h6>
            <p>please click the create booking button.</p>
          </a-col>
          <a-col :span="24" :md="4" style="display: flex;align-items: center;justify-content: flex-end;">
            <a-button @click="toCreateBooking" type="primary">
              Create Booking
            </a-button>
          </a-col>
        </a-row>
      </template>
      <a-row class="mt-5 mb-10">
        <a-col :span="12" style="text-align: left">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Total
              <span class="text-danger"> {{ countObjData }}</span>
              record
            </p>
          </a-tag>
        </a-col>
        <a-col :span="12" style="text-align: right">
          <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
        </a-col>
      </a-row>
      <div v-if="isLoaded" class="div-isLoaded">
        <a-spin />
      </div>
      <span v-else>
        <div v-if="listData.length != 0">
          <div v-for="(query, line) in listData" :key="'Ticket' + line">
            <a-card :bordered="false" class="mt-10 card-billing-info">
              <div class="col-info">
                <a-descriptions :column="1">
                  <template slot="title">
                    <p class="mb-0">No : {{ query.id }}</p>
                  </template>
                  
                  <a-descriptions-item label="Detail">
                    {{ query.detail_of_design }}
                  </a-descriptions-item>

                  <a-descriptions-item label="Deadline">
                    <p class="mt-5 mb-5">
                      {{ moment(query.deadline_date).format("DD / MM / YYYY") }}
                    </p>
                  </a-descriptions-item>


                  <a-descriptions-item label="Created At">
                    {{ moment(query.created_at).format("DD / MM / YYYY , HH:mm") }}
                  </a-descriptions-item>

                  <a-descriptions-item label="Remark">
                    {{ query.remark }}
                  </a-descriptions-item>

                  <a-descriptions-item label="Staff Coordinator"
                    v-if="query.status === 'approve' || query.status === 'success'">
                    <span v-for="(data, index) in query.staff_support_detail" :key="'staff_' + index">
                      - {{
                        data.staff_name + ', tel : ' + data.telephone
                      }}
                      <br>
                    </span>
                  </a-descriptions-item>

                  <a-descriptions-item label="Status">
                    <a-tag :color="query.status === 'wait'
                      ? '#ffc71e'
                      : (query.status === 'approve'
                        ? '#4C6793'
                        : (query.status === 'success' ? '#87d068' : 'red'))
                      ">
                      {{ query.status }}
                    </a-tag>
                  </a-descriptions-item>

                  <a-descriptions-item v-if="query.status == 'cancel'" label="Reason">
                    <a-tag color="red">
                      {{ query.reason }}
                    </a-tag>
                  </a-descriptions-item>

                </a-descriptions>
              </div>
              <div class="col-action">
                <div v-if="query.status === 'wait'">
                  <a-popconfirm title="Are you sure to Delete？" @confirm="deleteBooking(query.id)">
                    <a><a-icon :style="{ color: 'red', fontSize: '20px' }" type="delete" theme="filled" /></a>
                  </a-popconfirm>
                </div>
              </div>
              <div v-if="query.status === 'success'">
                <a @click="onShowModal('bookingInformation', 'Photo Information', query, line)">
                  <a-icon type="folder-open" :style="{ fontSize: '20px' }" theme="filled" /></a>
              </div>
            </a-card>
          </div>
        </div>
        <div v-else>
          <a-empty><span slot="description">
              No Booking .
              <a @click="toCreateBooking">please click the create booking button</a>
            </span></a-empty>
        </div>
      </span>
    </a-card>

    <!-- modal data -->
    <span v-if="isShowModal">
      <component :is="currentModalComponent" :viewModal="isShowModal" :onShowModal="onShowModal"
        @updateTableData="updateTableData" :onCloseModal="onCloseModal" :dataInformation="dataInformation"></component>
    </span>

  </div>
</template>

<script>
import bookingInformation from "./modal/booking-information.vue";

const columns = [
  {
    title: "Book Detail",
    dataIndex: "reason_detail",
    scopedSlots: { customRender: "reason_detail" },
  },
  {
    title: "Remark",
    dataIndex: "remark",
    className: "",
    scopedSlots: { customRender: "remark" },
  },
  {
    title: "Status",
    dataIndex: "status",
    className: "text-center",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "Action",
    dataIndex: "action",
    className: "text-center",
    scopedSlots: { customRender: "action" },
  },
];
const listData = [];
export default {
  data() {
    return {
      columns,
      listData,
      isLoaded: false,
      visible: false,
      objData: {},
      currentModalComponent: 'bookingInformation',
      isShowModal: false,
      dataInformation: null,
      modalTitle: '',
      perPage: 3,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
    };
  },
  mounted() {
    this.getListData();
  },
  components: {
    bookingInformation,
  },
  methods: {
    goToMainPage() {
      this.$router
        .push({
          path: "/booking/pr/",
        })
        .catch((err) => { });
    },
    onChangePage(currentPage) {
      this.currentPage = currentPage;
      this.offset = Number.parseInt(currentPage - 1) * Number.parseInt(this.perPage);
      this.getListData();
    },
    updateTableData({ updateData, idRecordTable }) {
      this.listData[idRecordTable] = updateData
    },
    toCreateBooking() {
      this.$router
        .push({
          path: "design/form/",
        })
        .catch((err) => { });
    },
    async getListData() {
      this.isLoaded = true;
      this.listData = []
      try {
        const res = await this.$http.get("/booking/design/me/?limit=" + this.perPage + "&offset=" + this.offset);
        if (res.status === 200) {
          this.listData = res.data.results
          this.countObjData = res.data.count
          this.listData.sort((a, b) => {
            return b.id - a.id;
          });
          this.isLoaded = false;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.isLoaded = false;
        this.listData = [];
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /booking/photo/`,
        });
      }
    },
    showDeleteConfirm(obj) {
      this.objData = Object.assign({}, obj);
      this.visible = true;
    },
    async deleteBooking(id) {
      try {
        const res = await this.$http.delete(`/booking/design/${id}/remove/`);
        if (res.status === 200) {
          this.getListData();
          this.visible = false;
          this.objData = {};
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) { }
    },
    onShowModal(modal, title, recData, idRecordTable) {
      this.currentModalComponent = modal
      this.isShowModal = true;
      this.modalTitle = title
      recData.idRecordTable = idRecordTable
      this.dataInformation = recData
    },
    onCloseModal() {
      this.isShowModal = false;
    },
  },
};
</script>
<style>
.div-isLoaded {
  text-align: center;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}
</style>